import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DashboardMenuComponent } from '../dashboard-menu/dashboard-menu.component';
import { RouterOutlet } from '@angular/router';
import { MenuData } from '../../models/menu-data';
import { User, UserRole } from '../../models/user';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'app-agent',
  imports: [CommonModule, DashboardMenuComponent, RouterOutlet],
  templateUrl: './agent.component.html',
  styleUrl: './agent.component.css'
})
export class AgentComponent implements OnInit {

  public user!: User;


  public menuData: MenuData = {
    sections: [
      {
        sectionTitle: 'Main Menu',
        items: [
          { label: 'Campaigns', route: '/agent/dashboard', icon: 'dashboard_icon.svg' },
          { label: 'Roster', route: '/agent/rosters', icon: 'roster_icon.svg' },
{ label: 'Invoices', route: '/agent/invoices', icon: 'payment_icon.svg' },
          { label: 'Video Analytics', route: '/agent/video-analytics', icon: 'video_analytics_icon.svg' },
          { label: 'Email In Bio', route: '/agent/email-in-bio', icon: 'email_icon.svg' },
          { label: 'Outreach', route: '/agent/outreach', icon: 'crm_icon.svg' },
          { label: 'CRM', route: '/agent/crm', icon: 'crm_icon.svg' }
        ]
      },
      {
        sectionTitle: 'Account',
        items: [
          { label: 'Account', route: '/agent/account', icon: 'account_icon.svg' },
          { label: 'Settings', route: '/agent/settings', icon: 'settings_icon.svg' }
        ]
      },
      {
        sectionTitle: 'System',
        items: [
          { label: 'FAQ', route: '/agent/faq', icon: 'faq_icon.svg' },
          { label: 'Help', route: '/agent/help', icon: 'help_icon.svg' },
          { label: 'Exit', route: '', queryParams: { stay: 1 }, icon: 'logout_icon.svg' }
        ]
      }
    ]
  };


  constructor(public loginService: LoginService) {}

  ngOnInit(): void {
    this.user = this.loginService.user;

    // Admin-only menu items.
    if (this.user?.role === UserRole.Admin) {
      this.menuData.sections[0].items.push({ label: 'Users', route: '/agent/users', icon: 'users_icon.svg' });
    }
  }

}
